
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/curriculum/bluebonnet",
      function () {
        return require("private-next-pages/curriculum/bluebonnet.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/curriculum/bluebonnet"])
      });
    }
  